function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { IS_TOUCH } from './constants';

// check value is a object and not null
export var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
};

// check value is a plain object
export var isPlainObject = function isPlainObject(value) {
  if (!isObject(value)) return false;
  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    return _constructor && prototype && _hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (error) {
    return false;
  }
};

// set object key and value
export var setObject = function setObject(obj, value) {
  if (!obj) obj = {};
  for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    obj[k] = v;
  }
};

// make a new object from old object
export var getNewObject = function getNewObject(value) {
  return Object.assign({}, value);
};

// check value is string and not empty
export var isString = function isString(value) {
  return typeof value === 'string' && value !== '';
};

// check value is number and not NaN
export var isNumber = function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
};

// check element is exist
export var isElementExist = function isElementExist(value) {
  return getElement(value) !== null;
};

// if value is an element then return value, if not then query value
export var getElement = function getElement(value) {
  return value instanceof HTMLElement ? value : document.querySelector(value);
};

// check value is img tag or not
export var isImg = function isImg(value) {
  return isElementExist(value) && getElement(value).tagName === 'IMG';
};

// check value is a function
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

// check value is percentage
export var isPercentage = function isPercentage(value) {
  return value.indexOf('%') > -1;
};

// get elemant style
export var getStyle = function getStyle(element, prop) {
  return element[prop] || element.style[prop] || window.getComputedStyle(element).getPropertyValue(prop);
};

// foreach set style
export var setStyle = function setStyle(element, obj) {
  for (var _i2 = 0, _Object$entries2 = Object.entries(obj); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      k = _Object$entries2$_i[0],
      v = _Object$entries2$_i[1];
    element.style[k] = isNumber(v) ? "".concat(v, "px") : v;
  }
};

// get mouse pageX and pageY
export var getPointer = function getPointer(event) {
  var isNotTouch = !IS_TOUCH || event.type === 'wheel';
  return {
    x: isNotTouch ? event.pageX : event.touches[0].pageX,
    y: isNotTouch ? event.pageY : event.touches[0].pageY,
    clientX: isNotTouch ? event.clientX : event.touches[0].clientX,
    clientY: isNotTouch ? event.clientY : event.touches[0].clientY
  };
};

// get transformX
export var getTransformX = function getTransformX(target) {
  var transform = getComputedStyle(target).transform;
  var mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(', ')[12]);
  mat = transform.match(/^matrix\((.+)\)$/);
  return mat ? parseFloat(mat[1].split(', ')[4]) : 0;
};

// get transformY
export var getTransformY = function getTransformY(target) {
  var transform = getComputedStyle(target).transform;
  var mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(', ')[13]);
  mat = transform.match(/^matrix\((.+)\)$/);
  return mat ? parseFloat(mat[1].split(', ')[5]) : 0;
};

// like .toFixed(2)
export var roundToTwo = function roundToTwo(value) {
  return +(Math.round(value + "e+2") + "e-2");
};

// limit value
export var minmax = function minmax(value, min, max) {
  return Math.min(Math.max(value, min), max);
};

// first letter to uppercase
export var upperFirstLetter = function upperFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
};